import React from "react";

import BuildingIcon from "@uui/Building07";

import ROUTES from "@app/common/routes";

import SideNavButton from "./SideNavButton";

const WorkspaceInviteLink = ({ expanded }: { expanded: boolean }) => (
  <SideNavButton
    Icon={BuildingIcon}
    label="Workspace Invitation!"
    activeUrls={[ROUTES.INVITATION_WORKSPACE, ROUTES.JOIN_WORKSPACE]}
    open={expanded}
    notifications={1}
    url={ROUTES.INVITATION_WORKSPACE}
    highlight
    testId="side-nav-workspace-invitation"
  />
);

export default WorkspaceInviteLink;
